/**
 * Collection of functions to help with Query params, and UTM information handling
 */
import type { ParsedUrlQuery } from 'querystring';

enum UTMParams {
  page_source = 'page_source',
  utm_id = 'utm_id',
  utm_source = 'utm_source',
  utm_medium = 'utm_medium',
  utm_campaign = 'utm_campaign',
  utm_term = 'utm_term',
  utm_content = 'utm_content',
}
// As per https://github.com/microsoft/TypeScript/issues/22892#issuecomment-772302314
type UTMParamValues = `${UTMParams}`;
export type UTMInfo = {
  [key in UTMParamValues]?: string;
};

export const getStringFromQueryParam = (query: ParsedUrlQuery | undefined, queryParamName: string) => {
  if (!query) {
    return undefined;
  }

  const queryParam = query[queryParamName];
  if (queryParam) {
    if (Array.isArray(queryParam) && queryParam.length > 0) {
      return queryParam[0];
    } else if (!Array.isArray(queryParam)) {
      return queryParam;
    }
  }
  return undefined;
};

export const extractUTMFromQueryParams = (query: ParsedUrlQuery): UTMInfo => {
  const result: ParsedUrlQuery = {};
  const enumKeys = Object.keys(UTMParams);
  for (const utmParam of enumKeys) {
    result[utmParam] = getStringFromQueryParam(query, utmParam);
  }
  return result;
};
